// @flow
import React, { Component } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchJSON } from '../helpers/api';

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showExtranetTermsOfUseModal: false, showAssetForSaleLink: false, showA4STermsOfUseModal: false,
            extranetTermsText: '', extranetTermsLoading: false, extranetTermsLoadingError: false,
            a4STermsText: '', a4STermsLoading: false, a4sTermsLoadingError: false,
        };

        this.checkIfAssetForSalePage = this.checkIfAssetForSalePage.bind(this);
        this.toggleExtranetTermsOfUse = this.toggleExtranetTermsOfUse.bind(this);
        this.loadExtranetTermsOfUse = this.loadExtranetTermsOfUse.bind(this);
        this.toggleA4STermsOfUse = this.toggleA4STermsOfUse.bind(this);
        this.loadA4STermsOfUse = this.loadA4STermsOfUse.bind(this);
    };

    componentDidMount() {
        this.checkIfAssetForSalePage();
    };

    checkIfAssetForSalePage() {
        // We only want to show the A4S link when they user is in the A4S section.
        this.setState({ showAssetForSaleLink: window.location.href.toLowerCase().indexOf("assetforsale") !== -1 });
    };

    toggleExtranetTermsOfUse(){
        this.setState(prevState => ({
            showExtranetTermsOfUseModal: !prevState.showExtranetTermsOfUseModal,
        }));
    };

    async loadExtranetTermsOfUse(e){
        e.preventDefault();
        let url = `/portal/Auth/GetExtranetTermsOfUse`;
        let response = await fetchJSON(url);
        this.setState({ extranetTermsText: response.data.extranetAgreementText, extranetTermsLoading: response.loading, extranetTermsLoadingError: response.error });
        this.toggleExtranetTermsOfUse();
    };

    toggleA4STermsOfUse(){
        this.setState(prevState => ({
            showA4STermsOfUseModal: !prevState.showA4STermsOfUseModal,
        }));
    };

    async loadA4STermsOfUse(e) {
        e.preventDefault();
        let url = `/portal/AssetForSale/GetA4STerms`;
        let response = await fetchJSON(url);
        this.setState({ a4STermsText: response.data.extranetAgreementText, a4sTermsLoading: response.loading });
        this.toggleA4STermsOfUse();
    };

    render() {
        return (
            <React.Fragment>
                <footer className="footer">
                    <div className="container-fluid">
                        <Row>
                            <Col md={6}>
                                <div className="footer-links">
                                    <a href="#" onClick={(e) => this.loadExtranetTermsOfUse(e)}>Terms of Use</a><span> | </span>
                                    <a href="https://www.aercap.com/privacy-policy" target="_blank">Privacy Policy</a><span> | </span>
                                    <a href="https://www.aercap.com/cookie-policy" target="_blank">Cookie Policy</a>
                                    {this.state.showAssetForSaleLink &&
                                        <React.Fragment><span> | </span><a href="#" onClick={(e) => this.loadA4STermsOfUse(e)}>Asset For Sale Terms and Conditions</a></React.Fragment>
                                    }
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="text-md-right footer-links d-none d-md-block">
                                    <a href="mailto:customersupport@aercap.com">Contact Us</a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </footer>

                <Modal
                    isOpen={this.state.showExtranetTermsOfUseModal}
                    toggle={this.toggleExtranetTermsOfUse}
                    size={'lg'}>
                    <ModalHeader toggle={this.toggleExtranetTermsOfUse}>Terms of Use</ModalHeader>
                    <ModalBody>
                        {!this.state.extranetTermsLoading && <div dangerouslySetInnerHTML={{ __html: this.state.extranetTermsText }} />}
                    </ModalBody>
                    <ModalFooter className={this.state.bodyClass}>
                        <Button color="primary" onClick={this.toggleExtranetTermsOfUse}>Close</Button>{' '}
                    </ModalFooter>
                </Modal>

                <Modal
                    isOpen={this.state.showA4STermsOfUseModal}
                    toggle={this.toggleA4STermsOfUse}
                    size={'lg'}>
                    <ModalHeader toggle={this.toggleA4STermsOfUse}>Asset For Sale Terms and Conditions</ModalHeader>
                    <ModalBody>
                        {!this.state.a4STermsLoading && <div dangerouslySetInnerHTML={{ __html: this.state.a4STermsText }} />}
                    </ModalBody>
                    <ModalFooter className={this.state.bodyClass}>
                        <Button color="primary" onClick={this.toggleA4STermsOfUse}>Close</Button>{' '}
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
};

export default Footer;
